module.exports = __webpack_public_path__ + "components/country-flag/static/mh-968b7a76b8313aed11c7af4bf48daaa6.svg";